import { ContactDto } from '@/api/generated';
import {
  contactInfoTypeOptionsTranslation,
  ContactInfoTypeOptionsTranslation,
  ContactStatusOptionsTranslation,
  contactStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import {
  contactDetailsInfosTranslation,
  ContactDetailsInfosTranslation,
} from '@/assets/locales/views/contactsDetails/infos/contactDetails.infos.translation.pl.ts';
import { ContactDetailsTab } from '@/views/contactsDetails/model/ContactDetailsTab.enum';

export type ContactsDetailsTranslation = {
  header: {
    button: {
      addProcess: string;
      assign: string;
      assignCustomer: string;
      edit: string;
    };
    dialog: {
      assignContactOwner: {
        button: {
          cancel: string;
          submit: string;
        };
        ownerPlaceholder: string;
        title: string;
        toast: {
          noOwnerSelected: string;
        };
      };
    };
  };
  infos: ContactDetailsInfosTranslation & {
    clickContactToCopy: string;
    contactInfoTypeOptions: ContactInfoTypeOptionsTranslation;
    copiedSuccessfully: string;
  };
  main: {
    fields: Record<keyof Omit<ContactDto['basicContact'], 'contactId'>, string> & {
      customerNotAssigned: string;
    };
    statusOptions: ContactStatusOptionsTranslation;
  };
  tabs: Record<ContactDetailsTab, string>;
};

export const contactsDetailsTranslation: ContactsDetailsTranslation = {
  header: {
    button: {
      addProcess: 'Utwórz proces',
      assign: 'Przypisz opiekuna',
      assignCustomer: 'Przypisz klienta',
      edit: 'Edytuj',
    },
    dialog: {
      assignContactOwner: {
        button: {
          cancel: 'Anuluj',
          submit: 'Zapisz',
        },
        ownerPlaceholder: 'Wybierz opiekuna',
        title: 'Przypisz opiekuna',
        toast: {
          noOwnerSelected: 'Nie wybrano opiekuna',
        },
      },
    },
  },
  infos: {
    ...contactDetailsInfosTranslation,
    clickContactToCopy: 'Kliknij kontakt, aby go skopiować',
    contactInfoTypeOptions: contactInfoTypeOptionsTranslation,
    copiedSuccessfully: 'Kontakt skopiowany',
  },
  main: {
    fields: {
      companyPosition: 'Stanowisko',
      contactOwnerId: 'Opiekun',
      customerId: 'Klient',
      customerNotAssigned: 'Nie przypisano klienta',
      customerType: 'Typ klienta',
      displayName: 'Nazwa wyświetlana',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      name: 'Nazwa',
      note: 'Notatka',
      status: 'Status',
    },
    statusOptions: contactStatusOptionsTranslation,
  },
  tabs: {
    CONTACT_INFO: 'Dane kontaktowe',
    PROCESSES: 'Procesy',
    TASKS: 'Zadania',
  },
};
